<script>
	const Vue = require('vue');
	const model = require('model/model');
	const page = require('page');
	const utilities = require('utilities');
	const userContext = require('core/userContext');
	const accountService = require('services/accountService');
	const routeContext = require('core/routeContext');

	const analyticsUtilities = require('utilities/analyticsUtilities');
	const fireEvent = analyticsUtilities.fireEvent;
	const NAV_CLICK = analyticsUtilities.events.NAV_CLICK;

	const pubsub = require('events/pubsub');

	module.exports = {
		components: {
			'validated-input': require('components/validated-input.vue').default,
			'validated-form': require('components/validated-form.vue').default,
			'sign-up-icon': require('components/svg/sign-up-icon.vue').default,
			'authenticated-student-warning-message': require('components/authenticated-student-warning-message.vue').default
		},

		data: function () {
			return {
				recaptchaEnabled: window.readworks.config.recaptcha,
				sitekey: window.readworks.config.google.recaptcha_sitekey,
				email: '',
				password: '',
				firstName: '',
				lastName: '',
				recaptcha: null,
				passwordRegex: utilities.regexp.teacherPassword
			};
		},

		mounted() {
			Vue.nextTick(() => {
				let self = this;
				let sitekey = this.sitekey;
				let form = this.$refs.signupForm;
				utilities.closeModals();

				if (this.recaptchaEnabled) {
					/* eslint-disable */
					!(function tryToFindRecaptcha() {
						if (!window.grecaptcha.render) {
							setTimeout(tryToFindRecaptcha, 0);
						} else {
							window.grecaptcha.render('grecaptcha', {
								sitekey,
								callback: response => {
									self.recaptcha = response;
									form.onSubmitInternal();
								},
								size: 'invisible'
							});
						}
					})();
					/* eslint-enable */
				}
			});
		},

		methods: {
			onStudentLoginClick() {
				fireEvent(NAV_CLICK, {
					dest: 'student_login',
					origin: 'signup_main'
				});
			},

			signUp: function () {
				let params = {
					email: this.email,
					password: this.password,
					firstName: this.firstName,
					lastName: this.lastName,
					recaptcha: this.recaptcha || undefined
				};

				if (this.recaptchaEnabled && !this.recaptcha) {
					window.grecaptcha.execute();
					return undefined;
				}

				return accountService
					.teacherCreateAccount(params)
					.then(result => {
						let next = '/onboarding-role';

						userContext.initialize(result);
						pubsub.publish('logged-in');
						if (routeContext.getQuery('url')) {
							model.set('signUpReturnUrl', routeContext.getQuery('url'));
						}
						page(next);
					})
					.catch(error => {
						this.recaptcha = null;
						if (this.recaptchaEnabled) {
							window.grecaptcha.reset();
						}
						throw error;
					});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';
	@import 'components/adaptive-placeholder';

	.signup {
		section {
			.signup-image {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				flex: 1;
				background: linear-gradient(132deg, #fff 49%, #fff 50%, $c-grey-extra-light 51%, $c-grey-extra-light 100%);
				text-align: center;
				max-height: 8rem;
			}

			.signup-form-panel {
				flex: 1;

				h2.panel-title {
					text-align: center;
					margin-bottom: 0.5rem;
				}

				.student-login-link {
					a {
						text-decoration: underline;
						color: $c-slate-dark;
					}

					margin-bottom: 0.5rem;
				}

				.signup-form {
					margin: 0 2rem;
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.signup {
			section {
				display: flex;
				flex-wrap: wrap;

				.signup-image {
					max-height: none;
				}

				.signup-form-panel {
					h2.panel-title {
						margin: 2rem 5rem 0.5rem 5rem;
					}

					.student-login-link {
						margin-bottom: 2rem;
					}

					.signup-form {
						margin: 2rem 5rem 4rem 5rem;
					}
				}
			}
		}
	}
</style>
<template>
	<main
		id="content"
		class="main signup onboarding">
		<div class="main-content wrapper">
			<section>
				<div class="signup-image">
					<sign-up-icon></sign-up-icon>
				</div>
				<div class="signup-form-panel">
					<h2 class="panel-title">Educator / Parent Sign Up</h2>
					<div class="student-login-link text-centered">
						<a
							href="/student-authentication"
							@click="onStudentLoginClick"
							>(I'm a Student)</a
						>
					</div>
					<authenticated-student-warning-message v-if="userContext && userContext.isStudent()"> </authenticated-student-warning-message>
					<validated-form
						ref="signupForm"
						class="signup-form"
						autocomplete="off"
						:on-submit="signUp">
						<div class="input-wrapper">
							<validated-input
								class="firstName"
								type="text"
								:debounce-delay="50"
								required
								v-model.trim="firstName"
								name="firstName"
								maxlength="45"></validated-input>
							<label
								for=""
								placeholder="First Name"
								alt="First Name"></label>
						</div>
						<div class="input-wrapper">
							<validated-input
								class="lastName"
								type="text"
								:debounce-delay="50"
								required
								v-model.trim="lastName"
								name="lastName"
								maxlength="45"></validated-input>
							<label
								for=""
								placeholder="Last Name"
								alt="Last Name"></label>
						</div>
						<div class="input-wrapper">
							<validated-input
								type="email"
								class="email"
								:debounce-delay="50"
								override-message="Please enter a valid email"
								v-model.trim="email"
								name="email"
								required
								autocomplete="signup-email"></validated-input>
							<label
								for=""
								placeholder="Email"
								alt="Email"></label>
						</div>
						<div class="input-wrapper">
							<validated-input
								class="password"
								type="password"
								required
								v-model="password"
								minlength="8"
								:pattern="passwordRegex.source"
								maxlength="32"
								pattern-message="Passwords must be a minimum of 8 characters, and include both upper and lower case or a number or special character."
								name="password"
								autocomplete="new-password"></validated-input>
							<label
								for=""
								placeholder="Password"
								alt="Password"></label>
						</div>
						<div
							v-if="recaptchaEnabled"
							id="grecaptcha"></div>
						<div class="input-wrapper submit-wrapper">
							<button
								type="submit"
								class="button submit">
								Get Started
							</button>
						</div>
					</validated-form>
				</div>
			</section>
		</div>
	</main>
</template>
